import { container } from '@angular/core/src/render3/instructions';

export * from './home/home.component';
export * from './apps/admin/apps.admin.component';

export * from './identity/identity.service';
export * from './internal.message/internal.message.service';
export * from './maintenance.message/maintenance.message.service';
export * from './maintenance.message.modal/maintenance.message.component';
export * from './maintenance.message.modal/maintenance.message.service';
export * from './maintenance.message.modal/maintenance.message.modal.service';
export * from './help.message/help.message.service';
export * from './portal.message/portal.message.service';
export * from './faq.message/faq.message.service';
export * from './clarification.request/clarification.request.service';
export * from './clarification.request.history/clarification.request.history.service';
export * from './clarification.request/clarification.request.machine.service';
export * from './modification.request/modification.request.service';
export * from './modification.request.history/modification.request.history.service';
export * from './modification.request/modification.request.machine.service';
export * from './dataentry/dataentry.manifest.service';
export * from './dataentry/dataentry.attachment.service';
export * from './case/case.machine.service';
export * from './kpi/kpi.service';
export * from './kpi/indicator.component';
export * from './label/label.service';
export * from './profile/profile.service';
export * from './organization/organization.service';
export * from './case/case.service';
export * from './case.history/case.history.service';
export * from './case.category/case.category.service';
export * from './case.participant/case.participant.service';
export * from './faq.modal/faq.component';
export * from './bulletin/bulletin.service';
export * from './bulletin.history/bulletin.history.service';
export * from './bulletin.participant/bulletin.participant.service';
export * from './bulletin/bulletin.machine.service';
export * from './role/role.service';
export * from './workflow.template/workflow.template.service';
export * from './workflow.template.manifest/workflow.template.manifest.service';
export * from './workflow.instance/workflow.instance.service';
export * from './form/form.service';
export * from './dataentry/dataentry.service';
export * from './dataentry/dataentry.render.service';
export * from './dataentry/manualcreate/manualcreate.service';
export * from './notification/notification.service';
export * from './customprop.type/customprop.type.service';
export * from './customprop.value/customprop.value.service';
export * from './officialact/officialact.service';
export * from './officialact/officialact.content.service';
export * from './officialact/officialact.machine.service';

export * from './inspection/inspection.service';
export * from './inspection.entry/inspection.entry.service';

export * from './dashboard/container/container.component';
export * from './dashboard/dashboard.service';
export * from './dashboard/report/report.component';
export * from './dashboard/kpi/kpi.component';
export * from './dashboard/dataentry/manualcreate.component';

export * from './secgroup/secgroup.service';
export * from './secgroup.relation/secgroup.relation.service';

export * from './report/report.component';

export * from './universal/universal.service';
export * from './universal/universal.pipe';




// WEBPACK FOOTER //
// ./src/app/modules/index.ts